import { isExternal } from './env';

/**
 * device check
 */
export const isMobile = {
  Android: () =>
    navigator.userAgent.match(/Android/i) === null ? false : true,
  iOS: () =>
    [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod',
    ].includes(navigator.platform) ||
    (navigator.userAgent.includes('Mac') && 'ontouchend' in document),
  any: () => isMobile.Android() || isMobile.iOS(),
};

/**
 * deviceId, deviceName정보
 */
export const getDeviceId = () => {
  if (isMobile.any()) {
    if (isMobile.Android()) {
      window.android?.getDeviceId();
    } else if (isMobile.iOS()) {
      window.webkit?.messageHandlers?.getDeviceId?.postMessage?.('');
    }
  }
};

/**
 * device unique id, name, app version, buildVersion 요청 함수
 */
export const getDeviceInfo = () => {
  if (isMobile.any()) {
    if (isMobile.Android()) {
      window.android?.getDeviceInfo();
    } else if (isMobile.iOS()) {
      window.webkit?.messageHandlers?.getDeviceInfo?.postMessage?.('');
    }
  }
};

/**
 * PC / Android / iOS 판단
 */
export const getDeviceType = () => {
  if (isMobile.any()) {
    if (isMobile.Android()) {
      return 'Android';
    } else if (isMobile.iOS()) {
      return 'iOS';
    }
  } else return 'PC';
};

/**
 * 생체인식 기능 제공 여부 확인
 */
export const isBioMetricsAvailable = () => {
  if (isMobile.any()) {
    if (isMobile.Android()) {
      window.android?.isBioMetricsAvailable();
    } else if (isMobile.iOS()) {
      window.webkit?.messageHandlers?.isBioMetricsAvailable?.postMessage?.('');
    }
  }
};

/**
 * BioMetrics 로그인 요청
 */
export const callBioMetrics = () => {
  if (isMobile.any()) {
    if (isMobile.Android()) {
      window.android?.callBioMetrics();
    } else if (isMobile.iOS()) {
      window.webkit?.messageHandlers?.callBioMetrics?.postMessage?.('');
    }
  }
};

/**
 * 암호화 요청
 */
export const encryptNative = (plainText, key) => {
  if (isMobile.any()) {
    if (isMobile.Android()) {
      window.android?.encrypt(plainText, key);
    } else if (isMobile.iOS()) {
      window.webkit?.messageHandlers?.encrypt?.postMessage?.(
        plainText + '/******/' + key,
      );
    }
  }
};

/**
 * 복호화 요청
 */
export const decryptNative = key => {
  if (isMobile.any()) {
    if (isMobile.Android()) {
      window.android?.decrypt(key);
    } else if (isMobile.iOS()) {
      window.webkit?.messageHandlers?.decrypt?.postMessage?.(key);
    }
  }
};

/**
 * native 토큰 저장
 */
export const setToken = token => {
  if (isMobile.any()) {
    if (isMobile.Android()) {
      window.android?.setToken(token);
    } else if (isMobile.iOS()) {
      window.webkit?.messageHandlers?.setToken?.postMessage?.(token);
    }
  }
};

/**
 * key event 수신 여부 설정
 */
export const setReceiveKeyEventOnOff = isOn => {
  if (isMobile.any()) {
    if (isMobile.Android()) {
      window.android?.setReceiveKeyEventOnOff(isOn);
    } else if (isMobile.iOS()) {
      if (isOn) {
        window.webkit?.messageHandlers?.setReceiveKeyEventOnOff?.postMessage?.(
          'On',
        );
      } else {
        window.webkit?.messageHandlers?.setReceiveKeyEventOnOff?.postMessage?.(
          'Off',
        );
      }
    }
  }
};

// @NOTE: 실행이 안되어 임시 주석 처리
// /**
//  * 키보드 노출
//  */
// export const showSoftKeyboard = () => {
//   if (isMobile.any()) {
//     if (isMobile.Android()) {
//       window.android?.showSoftKeyboard();
//     } else if (isMobile.iOS()) {
//       window.webkit?.messageHandlers?.showSoftKeyboard?.postMessage?.();
//     }
//   }
// };

/**
 * 키보드 숨김
 */
export const hideSoftKeyboard = () => {
  if (isMobile.any()) {
    if (isMobile.Android()) {
      window.android?.hideSoftKeyboard();
    } else if (isMobile.iOS()) {
      window.webkit?.messageHandlers?.hideSoftKeyboard?.postMessage?.();
    }
  }
};

// 입력 된 링크를 브라우저로 뛰우도록 전달하는 Bridge 함수
export const outLink = link => {
  if (isMobile.any()) {
    if (isMobile.Android()) {
      window.android?.outLink(link);
    } else if (isMobile.iOS()) {
      window.webkit?.messageHandlers?.outLink?.postMessage?.(link);
    }
  }
};

// 입력 된 링크를 Webview 내에서 뛰우도록 전달하는 Bridge 함수
export const inLink = link => {
  if (isMobile.any()) {
    if (isMobile.Android()) {
      window.android?.inLink(link);
    } else if (isMobile.iOS()) {
      window.webkit?.messageHandlers?.inLink?.postMessage?.(link);
    }
  }
};

// 구글 로그인 전용 InLink 함수
export const googleInLink = link => {
  if (isMobile.any()) {
    if (isMobile.Android()) {
      window.android?.googleInLink(link);
    } else if (isMobile.iOS()) {
      window.webkit?.messageHandlers?.googleInLink?.postMessage?.(link);
    }
  }
};

// Webview에서 파일 다운로드 실행 함수
export const downloadFile = (link, filename, mimetype) => {
  if (isMobile.any()) {
    if (isMobile.Android()) {
      window.android?.downloadFile(link, filename, mimetype);
    } else if (isMobile.iOS()) {
      window.webkit?.messageHandlers?.downloadFile?.postMessage?.(
        link,
        filename,
        mimetype,
      );
    }
  }
};

// 모바일 Device에서 SMS 문자를 발송하는 함수
export const sendSms = content => {
  if (isMobile.any()) {
    if (isMobile.Android()) {
      window.android?.sendSms(content);
    } else if (isMobile.iOS()) {
      window.webkit?.messageHandlers?.sendSms?.postMessage?.(content);
    }
  }
};

/**
 * device 세로화면 변경 요청 함수
 */
export const setPortrait = () => {
  if (isMobile.any()) {
    if (isMobile.Android()) {
      window.android?.setPortrait();
    } else if (isMobile.iOS()) {
      window.webkit?.messageHandlers?.setPortrait?.postMessage?.('');
    }
  }
};

/**
 * device 가로화면 변경 요청 함수
 */
export const setLandscape = () => {
  if (isMobile.any()) {
    if (isMobile.Android()) {
      window.android?.setLandscape();
    } else if (isMobile.iOS()) {
      window.webkit?.messageHandlers?.setLandscape?.postMessage?.('');
    }
  }
};

/**
 * Lips Test
 */
export const openLips = lipsUrl => {
  if (isMobile.any()) {
    if (isMobile.iOS()) {
      window.webkit?.messageHandlers?.openLips?.postMessage?.(lipsUrl);
    }
  }
};

/**
 * 개발 환경을 확인 하여, 웹(PC)/태블릿 여부를 리턴해주는 함수
 * @return {boolean}
 * @author Robin
 */
export const checkIsTablet = () => {
  // 내부망에서는 테스트를 위해 Tablet으로 동작 하도록 함
  return isExternal ? isMobile?.any() : true;
};

/**
 * GoogleInLink 성공 시 Callback 설정
 * @param {function} callback GoogleInLink Callback 함수
 */
export const setGoogleInLinkCallback = callback => {
  window.addEventListener('googleInLinkCallBack', callback);
};

/* 현재 태블릿 모드인지 여부 */
export const isTablet = checkIsTablet();

/**
 * 앱종료 Bridge 함수
 */
export const closeApp = () => {
  if (isMobile.any()) {
    if (isMobile.Android()) {
      window.android?.closeApp();
    } else if (isMobile.iOS()) {
      window.webkit?.messageHandlers?.closeApp?.postMessage?.('');
    }
  }
};

export const restart = () => {
  if (isMobile.any()) {
    if (isMobile.Android()) {
      window.android?.restart();
    } else if (isMobile.iOS()) {
      window.webkit?.messageHandlers?.restart?.postMessage?.('');
    }
  }
};

export const clearCache = () => {
  if (isMobile.any()) {
    try {
      if (isMobile.Android()) {
        window.android?.clearCache();
      } 
    } catch (e) {}
  }
};

export const isIOS = isMobile.iOS();
export const isAndroid = isMobile.Android();
export const isMobileDevice = isMobile.any();
